import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";
const sys = "/tsg-admin/sys";

const apis = {
  // /role/permissionEdit
  permissionEdit(path, data) {
    return request({
      //添加角色
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  getRolePower(path, data) {
    // 获取期刊下拉
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  delRole(path, data) {
    return request({
      //添加角色
      url: sys + path,
      method: "delete",

      data: data,
    });
  },
  modifyRole(path, data) {
    return request({
      //添加角色
      url: sys + path,
      method: "put",

      data: data,
    });
  },
  addRole(path, data) {
    return request({
      //添加角色
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  getRole(path, data) {
    return request({
      //获取角色
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  perSelect(path, data) {
    // 获取期刊下拉
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  resetPwd(path, data) {
    return request({
      //重置密码
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  deleteUser(path, data) {
    return request({
      //修改角色
      url: sys + path,
      method: "delete",

      data: data,
    });
  },
  upd(path, data) {
    return request({
      //修改角色
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  addUser(path, data) {
    return request({
      //角色列表
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  roleList(path, data) {
    return request({
      //角色列表
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  perList(path, data) {
    // 获取用户列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  getUserList(path, data) {
    // 获取用户列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  getPeriodicalInfo(path, data) {
    //修改期刊回显页面
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  updatePeriodical(path, data) {
    return request({
      //删除期刊
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  templateHistory(path, data) {
    //查询期刊历史模板
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // /periodical/templateHistory
  queryPeriodicalById(path, data) {
    return request({
      //删除期刊
      url: sys + path,
      method: "post",

      data: data,
    });
  },
  addPeriodical(path, data) {
    return request({
      //新增期刊
      url: sys + path,
      method: "post",
      data: data,
    });
  },
  queryTurnks(path, data) {
    // 流程模板
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  dropdownList(path, data) {
    // 流程模板
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  queryPeriodicalList(path, data) {
    //查询期刊列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  findAllList(path, data) {
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  findOneList(path, data) {
    //一级学科列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  findTwoList(path, data) {
    //二级学科列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  login(data) {
    return request({
      url: sys + "/login",
      method: "post",
      data,
    });
  },
  postSys(path, data, isString) {
    return request({
      url: sys + path,
      method: "post",
      isString: isString !== false,
      jsonString: true,
      data,
    });
  },
  getSys(path, params) {
    return request({
      url: sys + path,
      method: "get",
      params,
    });
  },
  deleteSys(path, id, type) {
    return request({
      url: sys + path,
      method: type || "delete",
      data: {
        id,
      },
    });
  },
  putSys(path, data, isString) {
    return request({
      url: sys + path,
      method: "put",
      data: data,
      isString,
    });
  },
  getCourse(params) {
    // 期刊详情
    return request({
      url: "/tsg/web/subject/findTreeMapAll",
      method: "get",
      params: params,
      isToken: true,
    });
  },

  deleteProcess(path, data, type) {
    return request({
      url: sys + path,
      method: type || "delete",
      data: data,
    });
  },
  checkAccount(data) {
    return request({
      url: sys + "/user/checkAccount",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // v2.6.1 外审设置
  // /sys/expertAudit/getPerList 根据刊社id查询期刊列表
  getPerList(data) {
    return request({
      url: sys + "/expertAudit/getPerList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },

  // 获取自定义外审设置开关 /expertAudit/getOpen
  expertAuditStatus(data) {
    return request({
      url: sys + "/expertAudit/getOpen",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // 保存外审开关状态
  saveExpertAuditStatus(data) {
    return request({
      url: sys + "/expertAudit/open",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // /sys/expertAudit/getCostomOption查看外审自定义选项及其他设置
  getExpertAuditSettings(data) {
    return request({
      url: sys + "/expertAudit/getCostomOption",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // 外审设置保存
  saveExpertSettings(data, isString) {
    return request({
      url: sys + "/expertAudit/costomOption",
      method: "post",
      isString: isString !== false,
      jsonString: true,
      data,
    });
  },
  // 校样设置（原清样设置） /sys/proof/save 保存/修改清样设置
  savePeriodicalProof(data, isString) {
    return request({
      url: sys + "/proof/save",
      method: "post",
      jsonString: true,
      data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 校样设置回显 /sys/proof/detail
  getPeriodicalProof(data) {
    return request({
      url: sys + "/proof/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  publishProcessList(data) {
    // 流程列表
    return request({
      url: sys + "/publishProcess/list",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  publishProcessSave(data) {
    // 保存流程
    return request({
      url: sys + "/publishProcess/save",
      method: "post",
      jsonString: true,
      data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  dropdownList(data) {
    // 修改期刊-出版流程下拉列表
    return request({
      url: sys + "/publishProcess/dropdownList",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  publishProcessDel(data) {
    // 修改期刊-出版流程下拉列表
    return request({
      url: sys + "/publishProcess/del",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  publishProcessGet(data) {
    // 修改期刊-出版流程下拉列表
    return request({
      url: sys + "/publishProcess/get",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  groupList(path, data) {
    // 用户组列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  addUserGroup(path, data) {
    // 新建群组
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  getUserListData(path, data) {
    // 用户列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  delUserGroup(path, data) {
    // 删除群组
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  membersPage(path, data) {
    // 组员列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  selAddPage(path, data) {
    // 组员列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  memberList(path, data) {
    // 添加组员页面-组员列表
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  addMember(path, data) {
    // 添加组员页面-组员列表
    return request({
      url: sys + path,
      method: "post",
      jsonString: true,
      data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  delMember(path, data) {
    // 删除组员
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  // 3.1.4
  querySmsConfigDetail(path, data) {
    // 获取短信配置详情
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  querySmsTemplateList(path, data) {
    // 获取阿里短信模版列表-
    return request({
      url: sys + path,
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  saveSmsConfig(data) {
    // 保存短信配置
    return request({
      url: sys + "/smsAndDomain/saveSmsConfig",
      method: "post",
      jsonString: true,
      data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  querySmsSignListByKey(data) {
    // 根据accessKeyId和accessKeySecret获取阿里短信签名列表-3.1.4
    return request({
      url: sys + "/smsAndDomain/querySmsSignListByKey",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  querySmsTemplateListByKey(data) {
    // 根据accessKeyId和accessKeySecret获取阿里短信模板列表
    return request({
      url: sys + "/smsAndDomain/querySmsTemplateListByKey",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  getDomainInfo(data) {
    // 获取域名列表
    return request({
      url: sys + "/smsAndDomain/getDomainInfo",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  saveDomainConfig(data) {
    // 保存短信配置
    return request({
      url: sys + "/smsAndDomain/saveDomainConfig",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  getRealNameKeyConfig(data) {
    // 查询实名Key配置
    return request({
      url: sys + "/smsAndDomain/getRealNameKeyConfig",
      method: "get",
      params: data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  saveRealNameKeyConfig(data) {
    // 保存实名Key配置
    return request({
      url: sys + "/smsAndDomain/saveRealNameKeyConfig",
      method: "put",
      jsonString: true,
      data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  deleteRealNameKeyConfig(data) {
    // 删除实名Key配置
    return request({
      url: sys + "/smsAndDomain/deleteRealNameKeyConfig",
      method: "delete",
      data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  testRealNameKey(data) {
    // 验证实名Key配置
    return request({
      url: "/api/zw-user/userRealName/front/verify",
      method: "post",
      jsonString: true,
      data,
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });

  },
  sendLiuyanSms(data) {
    // 发送留言短信
    return request({
      url: sys + "/smsAndDomain/sendLiuyanSms",
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
  querySendLiuyanStatus(data) {
    // 获取发送短信详情
    return request({
      url: sys + "/smsAndDomain/querySendLiuyanStatus",
      method: "get",
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data);
    });
  },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/organizational.serve.js